import React, { useEffect, useContext } from "react";
import logoblanco from "../../../../img/solimat-logo.svg";
import { Button, Modal } from "react-bootstrap";


const ModalBasico: React.FC<{ show: any , handleClose: any }> = ({ show , handleClose }) => {




    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton={false} className='header-modal-observaciones-rd'>
                <span className='information-icon-orange big'></span>
                <Modal.Title>

                    <h2 className='title-obsevaciones-rd'> Advertencia </h2>


                </Modal.Title>
            </Modal.Header>
            <Modal.Body className='body-modal-observaciones-rd'>
                <p className='text-body-modal-observaciones-rd'>La suma total de los archivos a enviar excede el límite de 50MB. Proceda a adjuntarlos en diferentes envios </p>

            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ModalBasico;
